// extracted by mini-css-extract-plugin
export var createdDate = "_n1-1";
export var divider = "_n1-2";
export var headerDivider = "_n1-3";
export var messagesCard = "_n1-0";
export var messagesContainer = "_n1-7";
export var messagesContainerWrapper = "_n1-4";
export var pointerCapturingButtonBoxes = "_n1-a";
export var showLeftPanelButton = "_n1-9";
export var showMoreButton = "_n1-c";
export var showMoreButtonContainer = "_n1-b";
export var summaryTitle = "_n1-6";
export var systemMessageCardWrapper = "_n1-d";
export var topButtons = "_n1-8";
export var withPadding = "_n1-5";